import analysisWhole from './analysisWhole'
import dataview from './dataviewAnalysis'
import iosVisualizer from './iosVisualizer'
import androidVisualizer from './androidVisualizer'
import userInfo from './userInfo'
import {util} from '../utils'
let components = [
  analysisWhole,
  dataview,
  iosVisualizer,
  androidVisualizer,
  userInfo
]

components.forEach(component => {
  component.install = function (Vue) {
    Vue.component(util.toCamel(component.name), component)
  }
})

export default {
  analysisWhole,
  dataview,
  iosVisualizer,
  androidVisualizer,
  userInfo
}
